import * as React from 'react';

import { TextField } from '../../../../../../components/Field/common';
import { trackNavigationToCard } from './tracking';
import { TitleField } from '../../../../../../components/Field/common/TitleField';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const TitleFieldContainer: React.FC = () => {
  const { id, title, url } = useOfferContext();

  const handleClick = React.useCallback(() => {
    trackNavigationToCard({ id });
  }, [id]);

  return (
    <TextField>
      <TitleField url={url} onClick={handleClick}>
        {title}
      </TitleField>
    </TextField>
  );
};
